import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const applyFilterAreaHeight = 90;

export const ActionBar = styled.div`
  background-color: ${p => p.theme.actionBar.bg};
  box-shadow: ${p => p.theme.actionBar.boxShadow};
  color: ${p => p.theme.actionBar.fg};
  width: 100%;
  padding: 10px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;

  /* Set explicit height in order to account for that height in the wrapper */
  height: ${applyFilterAreaHeight}px;

  ${media.largeUp`
    display: none;
  `}
`;

export const ProductCount = styled.div`
  text-align: center;
`;
